export default class FrontendRoutes {
  static ACCOUNT_LOGIN = '/account/login';
  static ACCOUNT_PASSWORD_FORGOT = '/account/password/forgot';
  static ACCOUNT_PASSWORD_RESET = '/account/password/reset';

  static PROJECTS_TASK = (taskId) => `/projects/task/${taskId}`;
  
  static SMS_TOPUP = '/sms/top-up';
}